export default __webpack_public_path__ + "static/media/AddVendor.2ad2eaf7.svg";